module.exports = __webpack_public_path__ + "img/徒弟.85858960.png";